import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {ErrorPageComponent} from './error-page.component'
import {DescriptionModule} from '../description/description.module'
import {FooterModule} from '../footer/footer.module'
import { FooterGridModule } from '../footer-grid/footer-grid.module'

@NgModule({
    imports: [
        CommonModule,
        DescriptionModule,
        FooterModule,
        FooterGridModule
    ],
  declarations: [ErrorPageComponent],
  exports: [
    ErrorPageComponent
  ]
})
export class ErrorPageModule {
}
